import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class BusinessVerticalsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/business_verticals", { params: toSnakeCase(params) });
  }

  fetch(storeId, enabled, includes = []) {
    return securedAxiosInstance.get("/business_verticals", { params: { store_id: storeId, enabled, includes } });
  }

  fetchNewOptions(storeId) {
    return securedAxiosInstance.get("/business_verticals/new", { params: { store_id: storeId } });
  }

  create(storeId, data) {
    const params = toSnakeCase({ storeId, businessVertical: { ...data } });
    return securedAxiosInstance.post("/business_verticals", params);
  }

  update(businessVerticalId, data) {
    return securedAxiosInstance.put(`/business_verticals/${businessVerticalId}`, {
      business_vertical: toSnakeCase(data),
    });
  }
}

export default new BusinessVerticalsService();
